import { api } from './apiClient';

const unwrapError = (error, fallback) => {
  if (error.response) {
    const data = error.response.data;
    if (Array.isArray(data?.errors)) return data.errors.join(', ');
    return data?.message || `Server error: ${error.response.status}`;
  }
  if (error.request) return 'Unable to reach the server. Please check your internet connection or try again later.';
  return error.message || fallback;
};

export const fetchComingSoonFeatureList = async (page = 1, pageSize = 50, searchtext = '') => {
  try {
    const response = await api.post('/api/v1/admin/coming-soon-features/list', {
      pagination: { page, pageSize },
      searchtext: searchtext || '',
    });
    return response.data;
  } catch (error) {
    throw new Error(unwrapError(error, 'Failed to load coming soon features'));
  }
};

export const createComingSoonFeature = async (payload) => {
  try {
    const response = await api.post('/api/v1/admin/coming-soon-features', payload);
    return response.data;
  } catch (error) {
    throw new Error(unwrapError(error, 'Failed to create coming soon feature'));
  }
};

export const updateComingSoonFeature = async (payload) => {
  try {
    const response = await api.put('/api/v1/admin/coming-soon-features', payload);
    return response.data;
  } catch (error) {
    throw new Error(unwrapError(error, 'Failed to update coming soon feature'));
  }
};

export const deactivateComingSoonFeature = async (id) => {
  try {
    const response = await api.delete(`/api/v1/admin/coming-soon-features/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(unwrapError(error, 'Failed to deactivate coming soon feature'));
  }
};

export const fetchComingSoonFeatureRegistrations = async (id) => {
  try {
    const response = await api.get(`/api/v1/admin/coming-soon-features/${id}/registrations`);
    return response.data;
  } catch (error) {
    throw new Error(unwrapError(error, 'Failed to load notify list'));
  }
};
